import { createSlice } from "@reduxjs/toolkit";
import { apiSlice } from "../../Pages/LoginPage/store/loginSlice";

const initialState = {
  token: localStorage.getItem("token") || null,
  isAuthenticated: !!localStorage.getItem("token"),
  hasLabsPermission: JSON.parse(localStorage.getItem("hasLabsPermission")) || false,
  hasActivePlan: JSON.parse(localStorage.getItem("hasActivePlan")) || false,
  whoami: JSON.parse(localStorage.getItem("whoami")) || null,
  status: "idle",
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      state.hasLabsPermission = false;
      state.whoami = null;
      localStorage.removeItem("token");
      localStorage.removeItem("whoami");
      localStorage.removeItem("hasLabsPermission");
      localStorage.removeItem("hasActivePlan");
      localStorage.removeItem("comingFromMenu");
    },
    setCredentials: (state, action) => {
      const { access_token } = action.payload;
      state.token = access_token;
      state.isAuthenticated = true;
      localStorage.setItem("token", access_token);
    },
    setWhoami: (state, action) => {
      state.whoami = action.payload;
      localStorage.setItem("whoami", JSON.stringify(action.payload));
    },
    setPermissions: (state, action) => {
      const hasLabsPermission = action.payload.includes("labs");
      state.hasLabsPermission = hasLabsPermission;
      localStorage.setItem("hasLabsPermission", JSON.stringify(hasLabsPermission));
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(apiSlice.endpoints.login.matchFulfilled, (state, action) => {
        const token = action.payload.access_token;
        state.token = token;
        state.isAuthenticated = true;
        localStorage.setItem("token", token);
      })
      .addMatcher(apiSlice.endpoints.fetchPermissions.matchFulfilled, (state, action) => {
        const permissions = action.payload;
        const hasLabsPermission = Array.isArray(permissions)
          ? permissions.includes("labs")
          : typeof permissions === "object" && permissions.labs === true;
        
        state.hasLabsPermission = hasLabsPermission;
        localStorage.setItem("hasLabsPermission", JSON.stringify(hasLabsPermission));
      })
      .addMatcher(apiSlice.endpoints.payments.matchFulfilled, (state, action) => {
        const payments = action.payload;
        const currentDate = new Date();

        const hasActivePlan = Array.isArray(payments) && payments.some(payment => {
          const expirationDate = new Date(payment.expiration_date);
          return expirationDate > currentDate;
        });

        state.hasActivePlan = hasActivePlan;
        localStorage.setItem("hasActivePlan", JSON.stringify(hasActivePlan));
      })
      .addMatcher(apiSlice.endpoints.login.matchRejected, (state, action) => {
        state.error = action.error.message;
        state.token = null;
        state.isAuthenticated = false;
        state.hasLabsPermission = false;
        localStorage.removeItem("token");
        localStorage.removeItem("hasLabsPermission");
        localStorage.removeItem("hasActivePlan");
      });
  },
});

export const { logout, setCredentials, setWhoami, setPermissions } = authSlice.actions;
export default authSlice.reducer;
